{
  const BaseModule = require('_base/base')

  const CLASS_HAS_VISIBLE_EXPLANATION = 'has__visibleExplanation'
  const CLASS_HAS_RESERVED_PLACE = 'has__reservedPlace'

  // based on css-animation, see explanation.pcss
  const DEFAULT_SHIFT_SIZE = 20
  const ANIMATION_DURATION = 100

  class ExplanationControl extends BaseModule {
    preInit() {
      this.$spread = this.$el.closest('.js__spread')
      this.$currentQuestion = this.$el.closest('.js__question')
      this.$questions = this.$spread.find('.js__question')

      this.addControl()
      this.bindSpread()
      this.collectShiftedEls()
    }

    get spreadHeight() {
      return this.$spread.height()
    }

    get hasReservedPlace() {
      return this.$el.hasClass(CLASS_HAS_RESERVED_PLACE)
    }

    addControl() {
      const $button = $('<button class="explanationControl">')
        .on('click', this.handleClick.bind(this))

      this.$el.prepend($button)
    }

    bindSpread() {
      this.$spread.on('spreadCreated', (_, spread) => this.spread = spread)
    }

    collectShiftedEls() {
      this.$shiftedEls = this.$questions
        .slice(this.$questions.index(this.$currentQuestion) + 1)
        .add(this.$spread.find('.test-result, .js__schoolTestResult'))
        .add(this.$spread.siblings('.footer'))
    }

    handleClick() {
      this.saveSpreadHeight()
      this.toggleExplanation()

      if (!this.hasReservedPlace) {
        this.resizeSpread()
        this.compareSpreadHeight()
        this.markShiftedQuestions()
      }
    }

    saveSpreadHeight() {
      this.savedSpreadHeight = this.spreadHeight
    }

    toggleExplanation() {
      this.$el.toggleClass('is__visible')
      this.$currentQuestion.toggleClass(CLASS_HAS_VISIBLE_EXPLANATION)
    }

    resizeSpread() {
      if (this.spread.resize) this.spread.resize()
    }

    compareSpreadHeight() {
      this.spreadHeightDiff = Math.abs(this.spreadHeight - this.savedSpreadHeight)
    }

    markShiftedQuestions() {
      const needsShiftDown = this.$currentQuestion.hasClass(CLASS_HAS_VISIBLE_EXPLANATION)
      const classShifted = needsShiftDown ? 'is__shiftedDown' : 'is__shiftedUp'

      if (this.spreadHeightDiff < DEFAULT_SHIFT_SIZE) {
        this.setShiftSize(`${this.spreadHeightDiff}px`)
        setTimeout(() => this.setShiftSize(''), ANIMATION_DURATION)
      }

      this.$shiftedEls.addClass(classShifted)
      setTimeout(() => this.$shiftedEls.removeClass(classShifted), ANIMATION_DURATION)
    }

    setShiftSize(size) {
      this.$spread[0].style.setProperty('--testShiftSize', size)
    }
  }

  $('.test .questionExplanation, .glvrdExerciseExplanation').each(function() { new ExplanationControl($(this)) })
}
